import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const mediaUrl = (u) => {
  if (u == null) return "";
  if (typeof u !== "string") {
    return typeof u === "number" || typeof u === "boolean" ? String(u) : "";
  }
  if (!u) return "";
  return u.startsWith("/api") ? `${BACKEND}${u}` : u;
};

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("eff_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fetchPublicContent = async () => {
  const { data } = await axios.get(`${API}/public/content`);
  return data;
};

export const userApi = axios.create({ baseURL: API, withCredentials: true });
userApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("eff_user_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
